import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, Output, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalWizardComponent, ScApiService } from '@sc-ui';
import { LocalizationService } from 'src/services/localization.service';
import { UserService } from 'src/services/user.service';
import { texts } from './jobsite-toolbar.texts';

@Component({
  standalone: false,
  selector: 'app-jobsite-toolbar',
  templateUrl: './jobsite-toolbar.component.html',
  styleUrls: ['./jobsite-toolbar.component.scss']
})
export class JobsiteToolbarComponent implements AfterViewInit, OnChanges {

  @ViewChild('jobContainer')
  jobContainer: ElementRef;

  @ViewChild('confirmModal')
  confirmModal: ModalWizardComponent;

  texts = texts;

  @Input()
  project: any;

  @Input()
  isInCommentMode = false;

  @Output()
  isInCommentModeChange = new EventEmitter<any>();

  show = false;

  isInitialized = false;

  showComments = false;

  isBrowser = false;

  comments: any = [];

  mentionItems: any = [];

  mentionConfig = {
    triggerChar: '@',
    labelKey: 'Label',
    dropUp: true,
    mentionSelect: (item: any) => {
      return item.InsertionValue;
    }
  }
  unlisten: () => void;

  constructor(private renderer: Renderer2,
    private hostRef: ElementRef,
    @Inject(PLATFORM_ID) platformId: string,
    private api: ScApiService,
    private router: Router,
    private route: ActivatedRoute,
    public user: UserService,
    public loc: LocalizationService) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnChanges() {
    this.init();
  }

  ngAfterViewInit() {
    this.init();
  }

  // the project is loaded independently from the jobsite, so it can arrive before or
  // after this component is created
  private init() {

    if (!this.project || this.isInitialized) return;
    this.isInitialized = true;

    this.api.get('projects/' + this.project.Id + '/review/work-items').subscribe(a => {
      this.comments = a;
    });

    setTimeout(() => {
      this.show = true;
    }, 1000);
  }

  addComment() {
    this.startCommentMode();
  }

  startCommentMode() {
    this.isInCommentMode = true;
    this.isInCommentModeChange.next(this.isInCommentMode);
    setTimeout(() => {
      this.unlisten = this.renderer.listen('document', 'click', (event) => {
        this.handleJobsiteClick(event);
      });
    }, 10);

  }

  endCommentMode() {
    if (this.unlisten) {
      this.unlisten();
    }

    this.unlisten = null;
    this.isInCommentMode = false;
    this.isInCommentModeChange.next(this.isInCommentMode);
  }

  abortComment() {
    this.endCommentMode();
  }

  deleteComment(item) {
    if (item.Id == 0) {
      var index = this.comments.indexOf(item);
      this.comments.splice(index, 1);
      return;
    }
    this.api.delete('projects/' + this.project.Id + '/review/work-items/' + item.Id).subscribe(() => {
      var index = this.comments.indexOf(item);
      this.comments.splice(index, 1);
    });
  }

  closeComment(item) {
    item.Done = true;
    this.api.put('projects/' + this.project.Id + '/review/work-items/', item).subscribe(() => { });
  }

  reopenComment(item) {
    item.Done = false;
    this.api.put('projects/' + this.project.Id + '/review/work-items/', item).subscribe(() => { });
  }

  handleJobsiteClick(e) {

    if (this.hostRef.nativeElement.contains(e.target)) {
      return;
    }

    this.endCommentMode();

    e.preventDefault();

    // Get the body dimensions
    var wrapper: any = document.querySelector('.jobsite-wrapper');
    const body = document.body;
    const bodyWidth = wrapper.offsetWidth;
    const bodyHeight = wrapper.offsetHeight;

    // Get the click position relative to the body
    const clickX = e.pageX;
    const clickY = e.pageY - wrapper.offsetTop;

    // Calculate the percentage position
    const x = (clickX / bodyWidth) * 100;
    const y = (clickY / bodyHeight) * 100;

    var c = {
      Id: 0,
      X: Math.round(x),
      Y: Math.round(y),
      ProjectId: this.project.Id,
      justCreated: true
    };

    this.comments.push(c);
  }

  confirm() {

    this.api.post('projects/' + this.project.Id + '/review/confirm', null).subscribe(d => {
      this.project.Status = "AwaitingJobsiteRelease";
      this.project.StatusIndex = 7;
    });
  }

  goToProject() {
    this.router.navigateByUrl('/projects/' + this.project.Id);
    this.confirmModal.dismiss();
  }

  goToDashboard() {
    this.router.navigateByUrl('/dashboard');
    this.confirmModal.dismiss();
  }

}
